import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';
import type { LanguageCode } from '../types/i18n';

export const ownerMeApi = {
  updateLanguage: async (
    languageCode: LanguageCode,
  ): Promise<{ preferredLanguage: LanguageCode }> => {
    const res = await apiClient.patch<ApiResponse<{ preferredLanguage: LanguageCode }>>(
      API_PATHS.OWNER_LANGUAGE_UPDATE,
      { languageCode },
    );
    return res.data.data;
  },
};
